export default __webpack_public_path__ + "static/media/ale.3823f170.JPG";